module.exports = __webpack_public_path__ + "static/img/5.55651fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/5.png
// module id = j1eP
// module chunks = 1